const PURCHASE_TYPE = {
  ONE_TIME: 'oneTime',
  SUBSCRIPTION: 'subscription'
};

export { PURCHASE_TYPE };
